import { render, staticRenderFns } from "./glitAward.vue?vue&type=template&id=61328518&scoped=true&"
import script from "./glitAward.vue?vue&type=script&lang=js&"
export * from "./glitAward.vue?vue&type=script&lang=js&"
import style0 from "./glitAward.vue?vue&type=style&index=0&id=61328518&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61328518",
  null
  
)

export default component.exports